"use strict";
/* T5.72 — Rewards slider. Truck glyph used for the free-shipping marker at the end of the bar. */
var LKC_TRUCK_SVG = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M1.5 5.5h11v10h-11z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M12.5 8.5h4l3 3v4h-7z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><circle cx="6" cy="17" r="1.9" fill="#fff" stroke="currentColor" stroke-width="1.6"/><circle cx="16.5" cy="17" r="1.9" fill="#fff" stroke="currentColor" stroke-width="1.6"/></svg>';
/* T5.72 — Friendlier wording for the reward inside the "Almost there!…" sentence only.
   The short marker label under each circle keeps the raw thresholdTitle (e.g. "FREE PIN").
   Edit the phrases here to reword the message. */
function lkcRewardPhrase(title) {
    var t = (title || '').replaceAll('</br>', ' ').trim();
    if (/free\s*pin/i.test(t)) return 'a free sloth pin';
    if (/free\s*shipping/i.test(t)) return 'free shipping';
    return t;
}
/* Audit G4 (11 Oct 2026) — Free gifts the customer removed are remembered by PRODUCT ID for
   the rest of the tab session (sessionStorage), so the gift is not auto-added again on the
   next page load. Was: variant IDs held in memory only, and checked against variants[0] only.
   Storage access is wrapped because it can throw (blocked site data, private windows). */
function lkcReadDeletedFreeGifts() {
    try {
        var ids = JSON.parse(sessionStorage.getItem('lkcDeletedFreeGiftProductIds') || '[]');
        return Array.isArray(ids) ? ids.map(String) : [];
    } catch (error) {
        return [];
    }
}
window.theme = window.theme || {}
theme.PromotionalProgressbar = function() {
    function PromotionalProgressbar() {
        this.selector = {
            main: document.getElementById('promotional-progress'),
            bars: document.querySelectorAll('.promotional-progress > .progress > .bars > .bar'),
            threshold: document.querySelectorAll('.promotional-progress > .progress > .bars-threshold > .threshold.show'),
            heading: document.getElementById('progress-heading'),
            cartdraweritemcount: document.getElementById('cart-drawer-item-count'),
            cartcountbubble: document.getElementById('cart-count-bubble'),
            cartdrawer: document.getElementById('cart-drawer'),
            cartdraweroverlay: document.getElementById('cart-drawer-overlay'),
            formcartdrawer: document.getElementById('form-cart-drawer'),
            cartdrawerupsell: document.getElementById('cart-drawer-upsell'),
            cartdrawerpaymentmethod: document.getElementById('cart-drawer-payment-method'),
            cartdrawercheckout: document.querySelector('#cart-drawer > .cart-footer > #checkout'),
            cartdrawerbestsellers: document.getElementById('cart-drawer-best-sellers')
        }
        this.state = {
            closestLowerArray: [], 
            closestHigherArray: [],
            closestLowerThreshold: 0,
            closestHigherThreshold: 0,
            deletedFreeGift: lkcReadDeletedFreeGifts(), // Audit G4: product IDs (strings), persisted per tab
            lastCartItems: [],
            recentlyRemoved: [],
            recentlyCurrency: localStorage.getItem('lkcRecentlyCurrency') || null,
            recentlyFreeGiftProductIds: JSON.parse(localStorage.getItem('lkcRecentlyFreeGiftProductIds') || '[]'),
            isRecalculating: false,
            recalculateTimeout: null,
            processingFreeGifts: [] // Track free gift products currently being added or removed
        };
        this.load();
    }
    PromotionalProgressbar.prototype.load = async function() {
        var _ = this;
        if(!(_.selector.main)) return;

        if(_.state.recentlyCurrency !== _.selector.main.dataset.cartCurrency) {
            _.state.recentlyFreeGiftProductIds.forEach(async (productId) => {
                await _.checkfreegift([], 'remove', productId, '', '', '', '', '');
            });

            localStorage.setItem('lkcRecentlyCurrency', _.selector.main.dataset.cartCurrency);
            localStorage.setItem('lkcRecentlyFreeGiftProductIds', JSON.stringify([]));
        }

        if(_.selector.main.dataset.testmode === 'false') {
            window.promotionalProgressbar = window.promotionalProgressbar.filter(threshold => threshold.thresholdTestMode !== "true");
        } else {
            window.promotionalProgressbar = window.promotionalProgressbar.filter(threshold => threshold.thresholdTestMode === "true");
        } 
        await window.promotionalProgressbar.sort((a,b) => parseInt(a.threshold) - parseInt(b.threshold));
        if(window.promotionalProgressbar.length > 0) {
            const maxAmountThreshold = parseInt(window.promotionalProgressbar[window.promotionalProgressbar.length - 1].threshold);
            let prePossition = 0;
            window.promotionalProgressbar.forEach(bar => {
                const percentageAmountThreshold = parseInt(bar.threshold) / maxAmountThreshold;
                const currentThresholdPercentage = percentageAmountThreshold * 100;
                const calcPosition = (currentThresholdPercentage / 100) * 8;
                let roundedPosition = Math.round(calcPosition);
                if(prePossition == roundedPosition){
                  roundedPosition = roundedPosition + 1;
                }

                prePossition = roundedPosition;
                const thresholdBarEls = document.querySelectorAll('.promotional-progress > .progress > .bars-threshold > .threshold');
                if(thresholdBarEls.length > 0) {
                    Array.from(thresholdBarEls).map((el,index) => {
                        if((index+1) === roundedPosition) {
                            el.querySelector('.bar-text') && (el.querySelector('.bar-text').innerHTML = bar.thresholdTitle);
                            el.classList.add("show");
                            /* T5.72 LKC slider — pin the marker at its true % of the bar and give it a
                               reward photo (free gift) or a truck (free shipping). Visual layer only;
                               the free-gift add/remove logic below is unchanged. */
                            el.style.left = currentThresholdPercentage + '%';
                            var lkcImgWrap = el.querySelector('.bar-img');
                            if (lkcImgWrap && !lkcImgWrap.dataset.lkcDone) {
                                lkcImgWrap.dataset.lkcDone = '1';
                                if (bar.productId !== "" && bar.variantImage) {
                                    el.classList.add('is-gift');
                                    var lkcImg = document.createElement('img');
                                    lkcImg.src = bar.variantImage;
                                    lkcImg.alt = bar.productName || '';
                                    lkcImg.loading = 'eager';
                                    lkcImg.width = 40;
                                    lkcImg.height = 40;
                                    lkcImgWrap.appendChild(lkcImg);
                                } else {
                                    el.classList.add('is-shipping');
                                    lkcImgWrap.innerHTML = LKC_TRUCK_SVG;
                                }
                            }
                        }
                    })
                }          
            })
            _.selector.main.classList.add("active");
            _.recalculate();
        } else {
            _.selector.main.classList.remove("active");
            const activeThresholdBars = document.querySelectorAll('.promotional-progress > .progress > .bars-threshold > .threshold.show');  
            activeThresholdBars.forEach(threshold => {
                threshold.classList.remove("active");
            })
        }
    }
    PromotionalProgressbar.prototype.formatPrice = function(amount) {
        var _ = this;
        const currency = _.selector.main.dataset.cartCurrency || _.selector.main.dataset.currentCurrency || '';
        
        if (currency.toUpperCase() === 'EUR') {
            // EUR format: "," as decimal separator, "." as thousands separator
            const parts = amount.toFixed(2).split('.');
            const integerPart = parts[0];
            const decimalPart = parts[1];
            
            // Add thousands separator (.)
            const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            
            return formattedInteger + ',' + decimalPart;
        } else {
            // Default format: "." as decimal separator
            return amount.toFixed(2);
        }
    }
    PromotionalProgressbar.prototype.recalculate = async function(cartData) {
        var _ = this;
        if (theme.CartTransactions.blocked()) return;
        
        // Clear any pending recalculation
        if(_.state.recalculateTimeout) {
            clearTimeout(_.state.recalculateTimeout);
            _.state.recalculateTimeout = null;
        }
        
        // If already recalculating, debounce the call
        if(_.state.isRecalculating) {
            _.state.recalculateTimeout = setTimeout(() => {
                _.recalculate();
            }, 100);
            return;
        }
        
        // Set flag to prevent concurrent executions
        _.state.isRecalculating = true;
        
        _.selector.cartdrawercheckout.disabled = true;
        /* T5.76 — Reuse the cart JSON the caller already fetched (e.g. updatequantity's
           cart/change.js response carries total_price/original_total_price/items) instead of
           re-reading the cart we just changed. Falls back to fetching when no cartData is
           passed (drawer open, /cart page, init, gift cascade). Same numbers either way. */
        await (cartData
            ? Promise.resolve(cartData)
            : fetch(window.Shopify.routes.root + 'cart.js', {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
              }}).then(response => response.json()))
        .then(async data => {
            // Calculate both totals: discounted (for gifts & shipping) and original (for discount)
            const cart_total = data.total_price / 100; // (for gifts & shipping)
            const original_cart_total = data.original_total_price / 100; // (for discount)
            
            // Helper function to get appropriate total based on threshold type
            const getThresholdTotal = function(promo) {
                return promo.thresholdType !== "Discount" ? cart_total : original_cart_total;
            };

            // Detect recently removed items (any product removed, not only free gifts)
            try {
                const prevItems = Array.isArray(_.state.lastCartItems) ? _.state.lastCartItems : [];
                const currItems = Array.isArray(data.items) ? data.items : [];
                const currKeys = new Set(currItems.map(i => `${i.product_id}:${i.variant_id}`));
                const removedNow = prevItems.filter(i => !currKeys.has(`${i.product_id}:${i.variant_id}`));
                // T5.55 — DISABLED. These "Would you like to add X to your cart?" re-add
                // prompts were queueing EVERY removed item, stacking into a long list that
                // pushed the actual cart contents off-screen (see cart screenshots). The
                // re-add prompt was only ever wanted for removed FREE GIFTS, and that is
                // already handled separately by the free-gift-unlocked flow (initiatefreegift).
                // So we no longer queue regular removed items: recentlyRemoved stays empty and
                // renderRecentlyRemoved() renders nothing (its empty #recently-removed-items
                // container has no CSS of its own, so it takes zero space). To re-enable,
                // restore the removedNow.forEach push from git history.
                void removedNow;
                // Remove entries that came back to cart
                _.state.recentlyRemoved = _.state.recentlyRemoved.filter(r => !currKeys.has(`${r.product_id}:${r.variant_id}`));
                // Update last snapshot
                _.state.lastCartItems = currItems;
            } catch(e) {
                // Fail-safe; do not block cart
            }
            if(window.promotionalProgressbar.length > 0 && (cart_total > 0 || original_cart_total > 0)) {
                const freeShippingUnlocked = document.getElementById("free-shipping-unlocked");        
                const freeGiftLocked = document.getElementById('free-gift-locked');
                const freeGiftUnlockedContainer = document.getElementById("free-gift-unlocked");
                const freeShippingLocked = document.getElementById("free-shipping-locked");
                freeShippingUnlocked && freeShippingUnlocked.classList.remove("active");
                freeGiftLocked && freeGiftLocked.classList.remove('active');
                freeShippingLocked && freeShippingLocked.classList.remove('active');
                freeGiftUnlockedContainer && (freeGiftUnlockedContainer.innerHTML = ''); /* Audit C1 (11 Oct 2026) — null-guard: #free-gift-unlocked is absent from the empty-cart markup, so a stale "empty" drawer with a non-empty cart threw here and aborted the whole recalculation */
                _.state.closestLowerArray = [];
                _.state.closestHigherArray = [];
                _.state.closestHigherThreshold = 0;
                _.state.closestLowerThreshold = 0;
                const freeGiftPromo = window.promotionalProgressbar.filter(promo => promo.productId !== "");
               
                for(const promo of freeGiftPromo) {  
                    const thresholdTotal = getThresholdTotal(promo);
                    if(thresholdTotal < parseInt(promo.threshold)) {                      
                        if(promo.productId !== "") {
                           await _.checkfreegift(promo.variants, 'remove', promo.productId, promo.productName, promo.variantImage, promo.productHandle, promo.optionTriggerFound, promo.automaticallyAdded, data);
                        }
                    }
                    
                }
               
                for(const promo of window.promotionalProgressbar) {   
                    const thresholdTotal = getThresholdTotal(promo);
                    if(parseFloat(promo.threshold) <= thresholdTotal) {
                        _.state.closestLowerArray.push(promo);
                        _.state.closestLowerThreshold = promo.threshold;
                    }
                    if(parseFloat(promo.threshold) > thresholdTotal) {
                        _.state.closestHigherArray.push(promo);
                        _.state.closestHigherThreshold = promo.threshold;
                        break;
                    }                
                };
                if(_.state.closestLowerArray.length > 0) {
                   for(const promo of _.state.closestLowerArray) {
                        const thresholdTotal = getThresholdTotal(promo);
                        if(promo.productId !== "") {
                            _.checkfreegift(promo.variants, 'add', promo.productId, promo.productName, promo.variantImage, promo.productHandle, promo.optionTriggerFound, promo.automaticallyAdded, data);
                        }
                        if(thresholdTotal < parseInt(promo.threshold)) {
                            if(promo.variantid !== "") {
                                _.checkfreegift(promo.variants, 'remove', promo.productId, promo.productName, promo.variantImage, promo.productHandle, promo.optionTriggerFound, promo.automaticallyAdded, data);
                            }
                        }        
                        freeShippingUnlocked && freeShippingUnlocked.classList.add("active");
                        freeShippingUnlocked && (freeShippingUnlocked.querySelector(".details .title strong").textContent = promo.thresholdTitle.replace('</br>', ' '));
                    }
                }
                if(_.state.closestHigherArray.length > 0) {
                    for(const promo of _.state.closestHigherArray) {
                        const thresholdTotal = getThresholdTotal(promo);
                        const remainingThreshold = parseFloat(promo.threshold) - thresholdTotal;
                        const remainingMessage = promo ? promo.message.replace('[remaining_amount]',`${_.selector.main.dataset.currentCurrency}${_.formatPrice(remainingThreshold)}`).replace('[title]',`${promo.thresholdTitle.replaceAll('</br>',' ')}`).replace('[product_name]',`${promo.productName}`) : '';
                        /* T5.72 — Heading copy: "Almost there! Just $X more for REWARD", with the amount and the
                           reward name highlighted in the gradient's bright colour. The plain remainingMessage above
                           still feeds the free-gift-locked / free-shipping-locked detail blocks further down.
                           (To reword the heading, edit this template string.) */
                        const lkcHeadingMsg = promo ? `Almost there! Just <span class="lkc-rs-amt">${_.selector.main.dataset.currentCurrency}${_.formatPrice(remainingThreshold)}</span> more for <span class="lkc-rs-reward">${lkcRewardPhrase(promo.thresholdTitle)}</span>` : '';
                        promo ? _.selector.heading.closest(".progress-heading").classList.remove("empty-title") : _.selector.heading.closest(".progress-heading").classList.add("empty-title");
                        _.selector.heading.innerHTML = lkcHeadingMsg;
                        if(promo && promo.productId !== "" && freeGiftLocked) {                                   
                            freeGiftLocked.classList.add("active");
                            if(promo.variantImage !== '') {
                                let variantImage = document.createElement("img");
                                    const existingVariantImage = freeGiftLocked.querySelector('img');
                                    existingVariantImage && existingVariantImage.remove();
                                    variantImage.src = promo.variantImage;
                                    variantImage.width = '50';
                                    variantImage.height = '50';
                                    variantImage.alt = promo.productName;
                                    variantImage.title = promo.productName;
                                    variantImage.loading = 'eager';
                                    freeGiftLocked.querySelector(".image").append(variantImage);
                            }
                            freeGiftLocked.querySelector(".details > .title").innerHTML = remainingMessage;
                        } else {
                            freeShippingLocked && freeShippingLocked.classList.add('active');
                            freeShippingLocked && (freeShippingLocked.querySelector(".details > .title > span").innerHTML = remainingMessage);  
                        }
                    }
                }
                const activeThresholdBars = document.querySelectorAll('.promotional-progress > .progress > .bars-threshold > .threshold.show');
                //debugger;
                activeThresholdBars.forEach((bar,index) => {
                    if(index < parseInt(_.state.closestLowerArray.length)) {
                        bar.classList.add('active');
                    } else {
                        bar.classList.remove('active');
                    }
                })
              
                const thresholds = _.selector.main.querySelectorAll('.threshold');
                const activeThresholds = _.selector.main.querySelectorAll('.threshold.show.active');
                let lastIndex = -1;
                if (activeThresholds.length > 0) {
                  const lastActive = activeThresholds[activeThresholds.length - 1];
                  lastIndex = Array.from(thresholds).indexOf(lastActive);
                }


                const main = _.selector.main;

                if (main) {
                  // Get all .threshold elements inside the main container
                  const thresholds = Array.from(main.querySelectorAll('.threshold'));
                  // Filter those that are .show
                  const showThresholds = thresholds.filter(el => el.classList.contains('show'));
                  // Filter those that are both .show and .active
                  const activeShowThresholds = showThresholds.filter(el => el.classList.contains('active'));
                
                  // Find the index of the next .threshold.show after the last .threshold.show.active
                  let nextShowIndex = -1;
                  let lastActiveIndex = -1;
                  if (activeShowThresholds.length > 0) {
                    const lastActive = activeShowThresholds[activeShowThresholds.length - 1];
                    lastActiveIndex = thresholds.indexOf(lastActive);
                    const lastActiveShowIndex = showThresholds.indexOf(lastActive);
                    if (lastActiveShowIndex < showThresholds.length - 1) {
                      // Next .show after last .show.active
                      nextShowIndex = thresholds.indexOf(showThresholds[lastActiveShowIndex + 1]);
                    }
                  } else if (showThresholds.length > 0) {
                    // If no active, the first .show is the next
                    nextShowIndex = thresholds.indexOf(showThresholds[0]);
                  }
                
                  // Progress bar logic
                  // T5.35a (26 May 2026) — Replaced `.at(-1)` with `[length-1]`.
                  // Array.prototype.at() requires iOS Safari 15.4+ (March 2022).
                  // Pre-15.4 throws TypeError: ...at is not a function. This
                  // script runs on every page (theme.liquid body) and recalculate
                  // fires multiple times per page-load (init + cart fetch +
                  // currency check + threshold changes), so a single stale iOS
                  // device generated all the Mobile-Safari JS errors Clarity
                  // surfaced over the last 3 days. The bracket-index form is
                  // semantically identical and works on every JS engine ever.
                  // Same fix mirrored in component-promotional-progress-bar.js:239.
                  /* T6.00 — Fill/knob (and the segment lighting below) now track the SAME
                     total the "Almost there! Just $X more" sentence uses for the next tier
                     to unlock (getThresholdTotal → discounted total for Shipping/Gift tiers).
                     Previously this was Math.max(cart_total, original_cart_total), so a cart
                     with an order-level code (e.g. a 10% welcome code: $80 cart, $72 payable)
                     drew the bar at 80/85 = 94% while the text asked for the true $13 gap to
                     the $85 goal — bar looked "too full". Now it draws at 72/85 ≈ 85%.
                     Carts with no discount are pixel-identical to before (both totals equal).
                     When every tier is unlocked there is no next tier; keep the old max() so
                     the bar still clamps to 100% in that state. */
                  const lkcNextPromo = _.state.closestHigherArray[0];
                  const visualProgressTotal = lkcNextPromo ? getThresholdTotal(lkcNextPromo) : Math.max(cart_total, original_cart_total);
                  const _ppBar = window.promotionalProgressbar;
                  const maxThreshold = parseFloat(_ppBar[_ppBar.length - 1].threshold);
                  const totalBars = _.selector.bars.length;
                  const segment = maxThreshold / totalBars;
                
                  _.selector.bars.forEach((bar, index) => {
                    // Activate bars up to the last active threshold or up to the next threshold to unlock
                
                    // For debugging
                    // console.log( lastActiveIndex, nextShowIndex, visualProgressTotal , (index + 1) * segment);
                    const shouldActivate =
                      (index <= lastActiveIndex) ||
                      (nextShowIndex !== -1 && index < nextShowIndex && visualProgressTotal >= (index + 1) * segment);
                
                    if (shouldActivate) {
                      bar.classList.add('active');
                    } else {
                      bar.classList.remove('active');
                    }
                  });

                  /* T5.72 LKC slider — drive the continuous gradient fill + Cecil knob from the same
                     progress total the segmented bars used. Visual layer only; nothing about the
                     free-gift / free-shipping cart logic changes. */
                  var lkcPct = maxThreshold > 0 ? Math.max(0, Math.min(100, (visualProgressTotal / maxThreshold) * 100)) : 0;
                  var lkcFill = main.querySelector('#lkc-rs-fill');
                  var lkcCecil = main.querySelector('#lkc-rs-cecil');
                  if (lkcFill) {
                    lkcFill.style.clipPath = 'inset(0 ' + (100 - lkcPct) + '% 0 0)';
                  }
                  if (lkcCecil) { lkcCecil.style.left = lkcPct + '%'; }

                  /* One-shot celebration glow on Cecil at the moment free shipping unlocks
                     (locked → unlocked CROSS). Gated so it never fires on page-load hydration,
                     on opening an already-unlocked cart, or on later tweaks while still unlocked. */
                  var lkcShipActive = !!main.querySelector('.threshold.is-shipping.active');
                  if (typeof _.state.lkcShipUnlocked === 'undefined') {
                    _.state.lkcShipUnlocked = lkcShipActive; // initialise; never fire on first paint
                  } else {
                    var lkcDrawerEl = document.getElementById('cart-drawer');
                    var lkcDrawerOpen = lkcDrawerEl && lkcDrawerEl.classList.contains('active');
                    if (lkcShipActive && !_.state.lkcShipUnlocked && lkcDrawerOpen && lkcCecil) {
                      lkcCecil.classList.remove('celebrate');
                      void lkcCecil.offsetWidth; // reflow so it can re-fire on a future unlock
                      lkcCecil.classList.add('celebrate');
                      setTimeout(function () { lkcCecil.classList.remove('celebrate'); }, 3200);
                    }
                    _.state.lkcShipUnlocked = lkcShipActive;
                  }
                }
                if(_.state.closestLowerArray.length >= window.promotionalProgressbar.length) {
                    _.selector.heading.closest(".progress-heading").classList.remove("empty-title");
                    _.selector.heading.innerHTML = `${_.selector.heading.dataset.finalHeading}`; 
                }
            }
            // Render recently removed prompts after we finish main UI updates
            _.renderRecentlyRemoved && _.renderRecentlyRemoved();
            if(cart_total > 0 || original_cart_total > 0) {
                _.selector.cartdrawerupsell.classList.add("active");
                _.selector.cartdrawerpaymentmethod && _.selector.cartdrawerpaymentmethod.classList.add("active"); /* T5.56 — null-guard: the payment-method block was removed from the cart (redundant with live express buttons) */
                _.selector.cartdrawercheckout.disabled = theme.CartTransactions.blocked() || (parseInt((document.querySelector('#cart-drawer-item-count .count-label') || {}).textContent) || 0) === 0; /* T5.55 idx17 — keep checkout disabled when cart is empty */
                _.selector.cartdrawerbestsellers.classList.remove("active");
            }
            if(cart_total == 0 && original_cart_total == 0) {
                await window.promotionalProgressbar.forEach(async (promo) => {
                    if(promo.productId !== "") {
                        _.checkfreegift(promo.variants, 'remove', promo.productId, promo.productName, promo.variantImage, promo.productHandle, promo.optionTriggerFound, promo.automaticallyAdded, data);
                    }
                })
                _.selector.heading.closest(".progress-heading").classList.remove("empty-title");
                _.selector.heading.textContent = _.selector.main.dataset.cartZeroText;
                _.selector.bars.forEach(bar => {
                   bar.classList.remove('active');
                })
                /* T5.72 LKC slider — empty cart: drain the fill and park Cecil at the start. */
                var lkcFillE = _.selector.main.querySelector('#lkc-rs-fill');
                var lkcCecilE = _.selector.main.querySelector('#lkc-rs-cecil');
                if (lkcFillE) { lkcFillE.style.clipPath = 'inset(0 100% 0 0)'; }
                if (lkcCecilE) { lkcCecilE.style.left = '0%'; }
                const activeThresholdBars = document.querySelectorAll('.promotional-progress > .progress > .bars-threshold > .threshold.show');
                activeThresholdBars.forEach(bar => {
                   bar.classList.remove('active');
                })
                _.selector.cartdrawerupsell.classList.remove("active");
                _.selector.cartdrawerpaymentmethod && _.selector.cartdrawerpaymentmethod.classList.remove("active"); /* T5.56 — null-guard (payment-method block removed) */
                _.selector.cartdrawercheckout.disabled = true;
                _.selector.cartdrawerbestsellers.classList.add("active");
            }
        })
        .catch(error => {
            console.error('Error in recalculate:', error);
        })
        .finally(() => {
            // Reset flag to allow future recalculations
            _.state.isRecalculating = false;
            _.selector.cartdrawercheckout.disabled = theme.CartTransactions.blocked() || (parseInt((document.querySelector('#cart-drawer-item-count .count-label') || {}).textContent) || 0) === 0; /* T5.55 idx17 — keep checkout disabled when cart is empty */
            
            // If there's a pending recalculation, execute it now
            if(_.state.recalculateTimeout) {
                clearTimeout(_.state.recalculateTimeout);
                _.state.recalculateTimeout = null;
                // Small delay to ensure current calculation is fully complete
                setTimeout(() => {
                    _.recalculate();
                }, 50);
            }
        });

    }
    PromotionalProgressbar.prototype.adjustFreeGiftQuantity = async function(key, targetQuantity) {
        const answer = await theme.CartTransactions.quantity(key, targetQuantity);
        await theme.CartTransactions.render(answer, { open: false, recalculate: false });
        this.renderRecentlyRemoved?.();
    }
    PromotionalProgressbar.prototype.checkfreegift = async function(variants, mode, productId, productName, variantImage, productHandle, optionTriggerFound, automaticallyAdded, cartData) {
        var _ = this;
        
        // Check if this free gift product is already being processed
        if(_.state.processingFreeGifts.includes(productId)) {
            return; // Skip if already processing
        }
        
        // Add to processing state
        _.state.processingFreeGifts.push(productId);
        
        try {
            /* T5.76 — Reuse the cart JSON recalculate already has (cartData) instead of
               re-fetching cart.js per reward tier. Each call targets a distinct product_id so
               the shared snapshot is correct; falls back to fetching when called without it. */
            await (cartData
                ? Promise.resolve(cartData)
                : fetch(window.Shopify.routes.root + 'cart.js', {
                    method: 'GET',
                    headers: {
                      'Content-Type': 'application/json'
                    }
                }).then(response => response.json()))
            .then(async data => {
                if(data.item_count > 0) {
                    const foundFreeGift = await data.items.find(item => parseInt(item.product_id) === parseInt(productId));
                    if(foundFreeGift) {
                        // If free gift exists, ensure quantity is always 1
                        if(parseInt(foundFreeGift.quantity) > 1) {
                            await _.adjustFreeGiftQuantity(foundFreeGift.key, 1);
                        }
                        // If mode is 'remove', remove it
                        if(mode === 'remove') {
                            await _.removefreegift(foundFreeGift.key); 
                        }
                    } else if(!foundFreeGift && mode === 'add') {
                        // Only add if it doesn't exist
                        // Audit G4 (11 Oct 2026): compare by product ID (was variants[0].id only)
                        if(automaticallyAdded === "true" && !_.state.deletedFreeGift.includes(String(productId))) {
                            await _.addfreegift(variants[0].id, productId);
                        } else {
                            await _.initiatefreegift(productId, variants, productName, variantImage, productHandle, optionTriggerFound, automaticallyAdded);
                        }
                    }         
                }
            })
            .catch(error => {
                console.error(error);
            });
        } finally {
            // Remove from processing state when done
            _.state.processingFreeGifts = _.state.processingFreeGifts.filter(id => id !== productId);
        }
    }
    /* Audit G4 (11 Oct 2026) — Called by component-cart-drawer.js (updatequantity) when the
       customer removes a free gift line. The cart line only carries the variant ID, so map it
       to its gift tier's product ID, remember that, and persist it for the tab session. */
    PromotionalProgressbar.prototype.rememberDeletedFreeGift = function(variantId) {
        var _ = this;
        const promo = (window.promotionalProgressbar || []).find(tier => tier.productId !== "" && Array.from(tier.variants || []).some(variant => String(variant.id) === String(variantId)));
        if(!promo) return;
        const productId = String(promo.productId);
        if(!_.state.deletedFreeGift.includes(productId)) {
            _.state.deletedFreeGift.push(productId);
        }
        try {
            sessionStorage.setItem('lkcDeletedFreeGiftProductIds', JSON.stringify(_.state.deletedFreeGift));
        } catch (error) {}
    }
    PromotionalProgressbar.prototype.initiatefreegift = async function(id, variants, productName, variantImage, productHandle, optionTriggerFound, automaticallyAdded) {
        var _ = this;
        const freeGiftOptionsEnabled = optionTriggerFound === 'true' ? true : false;
        const freeGiftAutomaticallyAdded = automaticallyAdded === 'true' ? true : false;
        const existingFreeAddItem = document.getElementById(`free-gift-unlocked-${id}`);
        existingFreeAddItem && existingFreeAddItem.remove();
        const freeGiftUnlockedInnerHtml = `<div class="image">
                    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 821.86 701.35" width="30px" height="30px" class="unlocked">
                        <defs>
                        <style>
                            .cls-1 {
                            fill: #000;
                            stroke-width: 0px;
                            }
                        </style>
                        </defs>
                        <rect class="cls-1" x="37.37" y="481.31" width="142.96" height="36.53" transform="translate(-235.2 121.35) rotate(-30)"></rect>
                        <path class="cls-1" d="M553.1,223.74v-23.07c0-88.72-72.18-160.9-160.9-160.9s-160.9,72.18-160.9,160.9v87.92h36.53v-87.92c0-68.58,55.8-124.38,124.38-124.38s124.38,55.79,124.38,124.38v44.15l-6.64,3.84-215.43,124.38-31.63,18.26-38.67,22.32,166.12,287.72,356.03-205.55-166.12-287.72-27.13,15.66ZM521.47,553.93l-43.09-74.63c-25.15,5.57-52.06-5.41-65.63-28.9-16.75-29.01-6.81-66.1,22.2-82.84,29.01-16.75,66.1-6.81,82.84,22.2,13.56,23.49,9.62,52.29-7.78,71.28l43.09,74.63-31.63,18.26Z"></path>
                        <rect class="cls-1" x="573.4" y="52.77" width="142.96" height="36.53" transform="translate(260.92 593.99) rotate(-60)"></rect>
                        <rect class="cls-1" y="381.94" width="142.95" height="36.53"></rect>
                        <rect class="cls-1" x="104.9" y="563.08" width="142.96" height="36.53" transform="translate(-415.27 443.42) rotate(-60)"></rect>
                        <rect class="cls-1" x="678.9" y="235.48" width="142.95" height="36.53"></rect>
                        <rect class="cls-1" x="642.18" y="134.47" width="142.96" height="36.53" transform="translate(19.24 377.29) rotate(-30)"></rect>
                    </svg>
                        <img src="${variantImage}" width="50" height="50" alt="${productName}" title="${productName}" loading="eager">
                    </div>
                    <div class="details">
                    <span class="title">You've unlocked a <strong>${productName}</strong></span>
                    <div class="${freeGiftOptionsEnabled ? 'variant-options-container no-select-options' : 'variant-options-container'}${freeGiftAutomaticallyAdded ? ' automatic-added' : ''}">
                        <select name="variant_options" title="Choose option" id="variant-options-${id}" class="variant-options${freeGiftOptionsEnabled ? ' freegift-quick-view-modal-btn' : ''}" data-product-url="/products/${productHandle}">
                            <option disabled selected ${freeGiftAutomaticallyAdded && 'value='+variants[0].id}>CHOOSE OPTION</option>
                        </select>
                        <button type="button" class="freegift-add-to-cart" ${!freeGiftAutomaticallyAdded && 'disabled'} ${freeGiftAutomaticallyAdded && 'data-automatic="true"'}>ADD TO CART</button>
                    </div>
                    </div>`;
        let freeGiftAddItem = document.createElement("div");
        freeGiftAddItem.id = `free-gift-unlocked-${id}`;
        freeGiftAddItem.classList.add("free-gift-unlocked");
        freeGiftAddItem.innerHTML = freeGiftUnlockedInnerHtml;
        const freeGiftUnlockedContainer = document.getElementById("free-gift-unlocked");
        freeGiftUnlockedContainer.append(freeGiftAddItem);
        freeGiftUnlockedContainer.classList.add("active");
        const variantOptionsSelect = document.getElementById(`variant-options-${id}`);
        if(variantOptionsSelect && !freeGiftOptionsEnabled && !freeGiftAutomaticallyAdded) {
            Array.from(variants).map(variant => {
                let option = document.createElement("option");
                option.value = variant.id;
                option.text = variant.title;
                variantOptionsSelect.append(option);
            })           
        }
    }
    PromotionalProgressbar.prototype.removefreegift = async function(key) {
        const answer = await theme.CartTransactions.quantity(key, 0);
        await theme.CartTransactions.render(answer, { open: false, recalculate: false });
        this.renderRecentlyRemoved?.();
        if (!theme.CartTransactions.blocked() && ['success', 'recovered', 'partial'].includes(answer.status)) this.recalculate(answer.cart);
    }
    PromotionalProgressbar.prototype.addfreegift = async function(id, productId) {
        const answer = await theme.CartTransactions.add({ id, quantity: 1 }, { onlyIfMissing: true, productId });
        await theme.CartTransactions.render(answer, { open: false, recalculate: false });
        if (['success', 'recovered', 'partial'].includes(answer.status) && answer.added?.product_id) {
            try {
                const existing = JSON.parse(localStorage.getItem('lkcRecentlyFreeGiftProductIds') || '[]');
                const ids = Array.isArray(existing) ? existing : [];
                if (!ids.includes(answer.added.product_id)) ids.push(answer.added.product_id);
                localStorage.setItem('lkcRecentlyFreeGiftProductIds', JSON.stringify(ids));
            } catch (error) {}
        }
        this.renderRecentlyRemoved?.();
        if (!theme.CartTransactions.blocked() && ['success', 'recovered', 'partial'].includes(answer.status)) this.recalculate(answer.cart);
    }
    PromotionalProgressbar.prototype.renderRecentlyRemoved = function() {
        var _ = this;
        if(!_.selector || !_.selector.formcartdrawer) return;
        let container = document.getElementById('recently-removed-items');
        if(!container) {
            container = document.createElement('div');
            container.id = 'recently-removed-items';
            container.className = 'recently-removed-items';
            const footerDetails = _.selector.formcartdrawer.querySelector('.cart-footer-details');
            if (footerDetails) {
                _.selector.formcartdrawer.insertBefore(container, footerDetails);
            } else {
                _.selector.formcartdrawer.appendChild(container);
            }
        }
        if(!Array.isArray(_.state.recentlyRemoved) || _.state.recentlyRemoved.length === 0) {
            container.innerHTML = '';
            return;
        }
        const buildItemHtml = function(item) {
            const title = item.product_title || item.title || 'this item';
            const imageHtml = item.image ? `<img src="${item.image}" width="50" height="50" alt="${title}" loading="eager">` : '';
            return `
            <div class="recently-removed-item" data-variant-id="${item.variant_id}">
                <div class="image">${imageHtml}</div>
                <div class="details">
                    <span class="title">Would you like to add <strong>${title}</strong> to your cart?</span>
                    <div class="actions">
                        <button type="button" class="recently-removed-add">ADD TO CART</button>
                    </div>
                </div>
            </div>`;
        }
        container.innerHTML = _.state.recentlyRemoved.map(buildItemHtml).join('');
        // Wire up buttons
        Array.from(container.querySelectorAll('.recently-removed-item .recently-removed-add')).forEach(btn => {
            btn.addEventListener('click', async function(e) {
                const parent = e.currentTarget.closest('.recently-removed-item');
                const variantId = parent && parent.getAttribute('data-variant-id');
                if(variantId) {
                    await _.addBackRemovedItem(parseInt(variantId));
                }
            });
        });
    }
    PromotionalProgressbar.prototype.addBackRemovedItem = async function(variantId) {
        const answer = await theme.CartTransactions.add({ id: variantId, quantity: 1 });
        await theme.CartTransactions.render(answer);
        if (['success', 'recovered', 'partial'].includes(answer.status)) {
            this.state.recentlyRemoved = this.state.recentlyRemoved.filter(item => parseInt(item.variant_id, 10) !== parseInt(variantId, 10));
            this.renderRecentlyRemoved();
        }
    }
    theme.PromotionalProgressbar = new PromotionalProgressbar;
}
theme.PromotionalProgressbar();